const TITLES = { EXPENSE: '费用报销审批单', PAYMENT: '付款审批单', LOAN: '借款审批单', INVOICE: '开票审批单' }
const OPERATIONS = { 0: '发起申请', 1: '通过', 2: '驳回', 3: '撤回', 4: '待审批', 5: '评论', 6: '未开始', 7: '转交', 8: '交接', 9: '撤回修改', 10: '线下结束' }
const present = value => value !== null && value !== undefined && value !== ''
const text = value => present(value) ? String(value) : '—'
const escape = value => text(value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
function money(value) {
  if (!present(value) || !Number.isFinite(Number(value))) return '—'
  return Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
const budget = value => ({ IN: '预算内', OUT: '预算外' }[value] || '—')
const join = values => values.filter(present).join('\n')
function fieldTable(fields) {
  return fields.map(([label, value]) => '<tr><th>' + escape(label) + '</th><td>' + escape(value) + '</td></tr>').join('')
}
function expenseBody(detail) {
  const a = detail.claim
  const fields = [['报销流程', a.claimType === 'EXECUTIVE' ? '总经理董事长报销' : '费用报销'], ['提交人', a.submitterName], ['报销人', a.beneficiaryName], ['报销部门', a.deptName], ['申请日期', a.claimDate], ['支付公司', a.payerCompanyName], ['支付公司税号', a.payerTaxNumber], ['预算类型', budget(a.budgetType)], ['报销事由', a.reason]]
  if (a.claimType === 'EXECUTIVE') {
    fields.splice(5, 3)
    fields.push(['报销类型', JSON.parse(a.reimbursementTypes || '[]').join('、')])
    if (a.invoiceStatus) fields.push(['发票情况', ({NONE:'无发票',PENDING:'待收发票'})[a.invoiceStatus] || a.invoiceStatus])
  }
  if (a.budgetType === 'OUT') fields.push(['预算外原因', a.budgetReason])
  if (a.claimType !== 'EXECUTIVE') fields.push(['采购事项', ({ NONE: '无', PROJECT: '项目采购', NON_PROJECT: '非项目采购' }[a.procurementType] || '—')])
  fields.push(['申请总额（元）', a.originalAmountProvided === false ? '未填报' : money(a.totalAmount)])
  if (a.amountReviewJson) { const review = JSON.parse(a.amountReviewJson); if (review.mode === 'TOTAL' && review.reason) fields.push(['核定依据', review.reason]) }
  if (a.noPaymentRequired) fields.push(['付款情况', '核定为0元，无需付款'])
  if (present(a.approvedAmount)) fields.push(['核定应付（元）', money(a.approvedAmount)])
  if (present(a.paidAmount)) fields.push(['已付金额（元）', money(a.paidAmount)])
  return fieldTable(fields)
}
function financeBody(type, detail) {
  const a = detail.application, c = detail.content || {}
  const fields = [['申请人', a.applicantName], ['申请部门', a.deptName], ['申请日期', a.applicationDate], [type === 'INVOICE' ? '开票公司' : type === 'LOAN' ? '费用承担公司' : '支付公司', a.companyName], ['关联合同', c.noContract ? '无' : a.contractName]]
  if (c.noContract) fields.push(['无合同说明', c.noContractReason])
  fields.push([type === 'INVOICE' ? '开票金额（元）' : type === 'LOAN' ? '借款金额（元）' : '付款金额（元）', money(a.amount)])
  if (type !== 'INVOICE') fields.push(['预算类型', budget(a.budgetType)], ['申请事由', a.reason])
  if (type === 'LOAN') fields.push(['涉及人工或材料采购费用', present(a.containsLaborMaterial) ? a.containsLaborMaterial ? '是' : '否' : '—'])
  if (type === 'PAYMENT') fields.push(['经办人', c.agentName], ['收款单位', c.recipientName], ['银行账户', c.bankAccount], ['开户行', c.bankName], ['发票情况', c.invoiceSituation], ['发票类型', c.invoiceType], ['付款方式', c.paymentMethod])
  if (type === 'INVOICE') fields.push(['购买单位', c.buyerName], ['票据类型', c.invoiceType], ['开票信息', c.invoiceInformation])
  if (present(a.approvedAmount)) {
    let review = {}; try { review = JSON.parse(a.amountReviewJson || '{}') || {} } catch (_) { }
    fields.push(['核定应付（元）', money(a.approvedAmount)], ['调整原因', review.reason], ['核对人', review.userName])
  }
  if (present(c.remark)) fields.push(['备注', c.remark])
  return fieldTable(fields)
}
function approvalBody(approval) {
  const records = approval.approvalRecordDtoList || []
  let body = records.length ? records.map((x, i) => {
    const people = (x.userList || []).map(u => u.userName).filter(present).join('、')
    const operation = x.operationTypeStr || OPERATIONS[Number(x.operationType)] || '处理记录'
    const remark = join([
    x.replyToUserName ? '回复：' + x.replyToUserName : '', x.remark,
    (x.mentionedUserList || []).length ? '@：' + x.mentionedUserList.map(u => u.userName).filter(present).join('、') : ''
    ])
    return '<tr class="approval-row">' + (i === 0 ? '<th rowspan="' + records.length + '">审批流程与记录</th>' : '') + '<td><div class="record-heading"><span>' + escape(join([x.taskName ? '【' + x.taskName + '】' : '', people, operation]).replace(/\n/g, ' ')) + '</span><time>' + escape(x.operateTime) + '</time></div>' + (remark ? '<div class="record-remark">' + escape(remark) + '</div>' : '') + '</td></tr>'
  }).join('') : fieldTable([['审批流程与记录', '未记录']])
  const cc = (approval.ccUserList || []).map(u => u.userName).filter(present).join('、')
  if (cc) body += fieldTable([['抄送人', cc]])
  return body
}
function statusStamp(approval) {
  const label = ({ 1: '审批中', 2: '已通过', 3: '已驳回', 4: '已取消', 5: '线下结束' })[Number(approval.status)] || approval.statusStr
  return label ? '<div class="status-stamp" aria-label="审批状态：' + escape(label) + '"><span>' + escape(label) + '</span></div>' : ''
}
function renderPrintDocument(title, number, body, approval) {
  const rows = (body.match(/<tr(?:\s|>)/g) || []).length
  const contentLength = body.replace(/<[^>]*>/g, '').length
  const fontSize = rows > 28 || contentLength > 2200 ? 9 : rows <= 18 ? 11 : 10
  return '<!doctype html><html lang="zh-CN"><head><meta charset="utf-8"><title>' + escape(title + ' ' + text(number)) + '</title><style>' + PRINT_STYLE + 'body{font-size:' + fontSize + 'pt}</style></head><body><main>' +
    '<header><h1>' + escape(title) + '</h1><div class="identifiers"><span>单号：' + escape(number) + '</span></div>' + statusStamp(approval) + '</header>' +
    '<table class="approval-sheet"><colgroup><col style="width:23%"><col style="width:77%"></colgroup><tbody>' + body + '</tbody></table>' +
    '<footer>打印时间：' + escape(new Date().toLocaleString('zh-CN', { hour12: false })) + '</footer></main></body></html>'
}
function buildFinanceApprovalPrint({ type, detail, approval }) {
  if (!TITLES[type]) throw Error('申请类型不支持打印')
  const a = type === 'EXPENSE' ? detail && detail.claim : detail && detail.application
  if (!a || !a.id || !a.workOrderId || !approval) throw Error('请先提交审批，再打印审批单')
  if (type !== 'EXPENSE' && a.applicationType !== type) throw Error('申请类型不匹配，请刷新后重试')
  if (present(approval.id) && String(approval.id) !== String(a.workOrderId)) throw Error('审批单已变化，请刷新后重试')
  const target = { EXPENSE: 'expenseClaim', PAYMENT: 'paymentApplication', LOAN: 'loanApplication', INVOICE: 'invoiceApplication' }[type]
  if (present(approval.targetType) && approval.targetType !== target) throw Error('审批类型不匹配，请刷新后重试')
  const number = type === 'EXPENSE' ? a.claimNo : a.applicationNo
  const title = type === 'EXPENSE' && detail.claim.claimType === 'EXECUTIVE' ? '总经理董事长报销审批单' : TITLES[type]
  return renderPrintDocument(title, number, (type === 'EXPENSE' ? expenseBody(detail) : financeBody(type, detail)) + approvalBody(approval), approval)
}
function buildFinanceApprovalSnapshotPrint({ type, approval, workOrderId }) {
  if (!TITLES[type] || !approval || String(approval.id) !== String(workOrderId)) throw Error('审批单已变化，请刷新后重试')
  const target = { EXPENSE: 'expenseClaim', PAYMENT: 'paymentApplication', LOAN: 'loanApplication', INVOICE: 'invoiceApplication' }[type]
  if (present(approval.targetType) && approval.targetType !== target) throw Error('审批类型不匹配，请刷新后重试')
  const basicLabels = new Set(['提交人', '报销流程', '报销类型', '申请单号', '申请类型', '申请人', '申请部门', '申请日期', '公司', '合同', '无合同说明', '金额', '事由', '预算类型', '是否涉及人工或材料采购费用', '经办人', '收款单位', '银行账户', '开户行', '发票情况', '发票类型', '付款方式', '购买单位', '票据类型', '开票信息', '备注', '关联审批单', '报销单号', '报销人', '报销部门', '报销日期', '支付公司', '支付公司税号', '预算外原因', '采购事项', '报销总额', '报销事由'])
  const fields = (approval.formInfoList || []).filter(x => basicLabels.has(x.label) && x.value && x.value.type === 'text').map(x => [x.label, x.value.text])
  if (!fields.length) throw Error('审批申请资料加载失败，请刷新后重试')
  const number = (fields.find(x => ['申请单号', '报销单号'].includes(x[0])) || [])[1]
  const title = fields.some(x => x[0] === '报销流程' && x[1] === '总经理董事长报销') ? '总经理董事长报销审批单' : TITLES[type]
  return renderPrintDocument(title, number, fieldTable(fields) + approvalBody(approval), approval)
}
const PRINT_STYLE = `
@page{size:A4 portrait;margin:9mm 12mm}
*{box-sizing:border-box}html,body{margin:0;padding:0;background:#fff;color:#111}
body{font-family:"SimSun","Songti SC","Noto Serif CJK SC",serif;font-size:10pt;line-height:1.35}
main{width:100%;max-width:186mm;margin:0 auto}header{position:relative;margin:0 0 2.5mm}h1{text-align:center;font-size:15pt;font-weight:400;margin:0 0 2.5mm}
.identifiers{display:flex;justify-content:space-between;gap:5mm;font-size:8pt;overflow-wrap:anywhere}
.status-stamp{position:absolute;right:3mm;top:2mm;width:22mm;height:22mm;border:1.4px solid #888;border-radius:50%;display:flex;align-items:center;justify-content:center;transform:rotate(-16deg);color:#888;opacity:.78;font-family:"Microsoft YaHei","PingFang SC",sans-serif;pointer-events:none}
.status-stamp:before{content:"";position:absolute;inset:1.2mm;border:1px solid #888;border-radius:50%}.status-stamp span{font-size:12pt;font-weight:600;border-top:1px solid #888;border-bottom:1px solid #888;padding:.8mm 0}
table{width:100%;border-collapse:collapse;table-layout:fixed}.approval-sheet{width:calc(100% - .5mm);height:250mm;border:1px solid #555}th,td{border:1px solid #555;padding:1mm 1.5mm;vertical-align:middle;text-align:left;white-space:pre-wrap;overflow-wrap:anywhere;word-break:break-word}
thead{display:table-header-group}th{font-weight:400}
tr{break-inside:avoid;page-break-inside:avoid}.approval-row{break-inside:auto;page-break-inside:auto}
.record-heading{display:flex;justify-content:space-between;flex-wrap:wrap;gap:1mm 3mm}.record-heading time{font-size:7.5pt;white-space:nowrap}.record-remark{margin-top:.7mm;white-space:pre-wrap}
p{margin:1mm 0;white-space:pre-wrap;overflow-wrap:anywhere}.empty{color:#555}footer{margin-top:2mm;font-size:7.5pt;color:#444;text-align:left}
@media print{html,body,main{width:100%;max-width:none}}
`

// Print an isolated document; the system dialog selects the computer's configured printers.
function printFinanceApproval(html, doc = document) {
  return new Promise((resolve, reject) => {
    const frame = doc.createElement('iframe')
    frame.setAttribute('title', '审批单打印')
    frame.setAttribute('aria-hidden', 'true')
    frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;'
    let invoked = false
    const cleanup = () => { if (frame.parentNode) frame.parentNode.removeChild(frame) }
    frame.onload = async () => {
      if (invoked) return
      invoked = true
      try {
        if (frame.contentDocument.fonts && frame.contentDocument.fonts.ready) await frame.contentDocument.fonts.ready
        frame.contentWindow.addEventListener('afterprint', cleanup, { once: true })
        frame.contentWindow.focus()
        frame.contentWindow.print()
        resolve()
      } catch (e) { cleanup(); reject(e) }
    }
    frame.onerror = () => { cleanup(); reject(Error('打印内容加载失败，请重试')) }
    frame.srcdoc = html
    doc.body.appendChild(frame)
  })
}
module.exports = { buildFinanceApprovalPrint, buildFinanceApprovalSnapshotPrint, printFinanceApproval, money }
